var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "width100" },
    [
      _c(
        "div",
        { staticClass: "width100" },
        [
          _vm._l(_vm.fileList, function (fileItem, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "fileItem",
                on: {
                  click: function ($event) {
                    return _vm.lookViewer(fileItem)
                  },
                },
              },
              [
                _c("div", { staticClass: "file-item-left" }, [
                  _vm.toSrcIcon(fileItem.name) !== "img"
                    ? _c("i", {
                        staticClass: "iconfont",
                        class: _vm.toSrcIcon(fileItem.name),
                      })
                    : _c("img", {
                        staticClass: "img",
                        attrs: {
                          src: fileItem.file_url || fileItem.url,
                          alt: "",
                        },
                      }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "file-item-right" }, [
                  _c("div", { staticClass: "file-name over-text" }, [
                    _vm._v(_vm._s(fileItem.name)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "file-size" }, [
                    _vm._v(_vm._s(_vm.toSizeFile(fileItem.size))),
                  ]),
                ]),
                _vm._v(" "),
                _vm.showClose
                  ? _c("i", {
                      staticClass: "file-close el-icon-error",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.fileDelete(index)
                        },
                      },
                    })
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _vm.fileList.length == 0 ? _c("div", [_vm._v("--")]) : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("image-viewer", {
        ref: "imageViewer",
        attrs: { "src-list": _vm.srcList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }